import { render, staticRenderFns } from "./ProcessBusinessRisksTable.vue?vue&type=template&id=43d0021a&"
import script from "./ProcessBusinessRisksTable.vue?vue&type=script&lang=js&"
export * from "./ProcessBusinessRisksTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports